import { useQuery } from "@tanstack/react-query";
import { client } from "../clients";

const fetchPreviewCount = async ({ query = {} }) => {
  return client("/preview_count", {
    method: "POST",
    data: query,
  }).then((data: any) => data);
};

const usePreviewCount = ({ query = {}, ...options }: any = {}) => {
  const payload = {
    countryCode: query.countryCode,
  };
  return useQuery({
    queryKey: ["preview-count", query],
    queryFn: () => fetchPreviewCount({ query: payload }),
    staleTime: 1000 * 60 * 10,
    gcTime: 1000 * 60 * 10,
    ...options,
  }) as any;
};

const fetchRowCount = async ({ query = {} }) => {
  return client("/row_counts", {
    method: "POST",
    data: query,
  }).then((data: any) => data);
};

const useRowCount = ({ query = {}, ...options }: any = {}) => {
  const payload = {
    countryCode: query.countryCode,
  };
  return useQuery({
    queryKey: ["row_counts", query],
    queryFn: () => fetchRowCount({ query: payload }),
    staleTime: 1000 * 60 * 10,
    gcTime: 1000 * 60 * 10,
    ...options,
  }) as any;
};

const fetchFieldCount = async ({ query = {} }) => {
  return client("/field_counts", {
    method: "POST",
    data: query,
  }).then((data: any) => data);
};

const useFieldCount = ({ query = {}, ...options }: any = {}) => {
  const payload = {
    countryCode: query.countryCode,
  };
  return useQuery({
    queryKey: ["field_counts", payload],
    queryFn: () => fetchFieldCount({ query: payload }),
    staleTime: 1000 * 60 * 10,
    gcTime: 1000 * 60 * 10,
    ...options,
  }) as any;
};

const fetchSegmentCount = async ({ query = {} }) => {
  return client("/segment_count", {
    method: "POST",
    data: query,
  }).then((data: any) => data);
};

const useSegmentCount = ({ query = {}, ...options }: any = {}) => {
  const payload = {
    country: query.country || query.countryName,
    tags: query.tags,
  };

  return useQuery({
    queryKey: ["segment_count", payload],
    queryFn: () => fetchSegmentCount({ query: payload }),
    staleTime: 1000 * 60 * 10,
    gcTime: 1000 * 60 * 10,
    ...options,
  }) as any;
};


type PreviewQuery = {
  tableName: string;
  countryCode: string;
};

const fetchPreviewData = async ({ query }: { query: PreviewQuery }) => {
  const payload = {
    countryCode: query.countryCode,
    table_name: `entity_${query.tableName.toLowerCase()}_table`,
  };

  const data = await client("/preview", {
    method: "POST",
    data: payload,
  });

  return data;
};

const usePreviewData = ({
  query,
  options,
}: {
  query: PreviewQuery;
  options?: any;
}) => {
  return useQuery({
    queryKey: ["preview", query.tableName, query.countryCode],
    queryFn: () => fetchPreviewData({ query }),
    enabled: !!query?.tableName && !!query?.countryCode,
    refetchOnWindowFocus: false,   // prevent refetch on tab switch
    refetchOnReconnect: false,     // prevent refetch on network reconnect
    refetchOnMount: false,
    ...options,
  }) as any;
};

export { usePreviewCount, useRowCount, useFieldCount, useSegmentCount, usePreviewData };